export const LOMT_NEO_PROJECT_ALIASES: string[] = [
  'bouncyheroes',
  'pegasus',
  'sparta',
  'basegame',
  'gardenflow',
  'bouncystrike',
];
